import { applyTheme } from './applyTheme'
import { loadThemeFromStorage, saveThemeToStorage } from './storage'

import type { ThemeJson } from './types'

// Позволяет задавать URL файла темы из окружения (Vite):
// VITE_THEME_URL=https://api.example.com/branding/theme.json
const THEME_URL: string = (import.meta as ImportMeta).env?.VITE_THEME_URL || '/theme.json'

async function fetchThemeJson (): Promise<ThemeJson | null> {
  try {
    const res = await fetch(THEME_URL, { cache: 'no-store' })
    if (!res.ok) return null
    return (await res.json()) as ThemeJson
  }
  catch {
    return null
  }
}

export async function bootstrapTheme (): Promise<void> {
  const saved = loadThemeFromStorage()
  if (saved) applyTheme(saved)

  const remote = await fetchThemeJson()
  if (!remote) return

  // Валидация: простая фильтрация строковых значений
  const cleanEntries = Object.entries(remote).filter(([ , v ]) => typeof v === 'string' && v.trim().length > 0)
  const themeVars: Record<string, string> = Object.fromEntries(cleanEntries)

  applyTheme(themeVars)
  saveThemeToStorage(themeVars)
}
